/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "bell-8b0530d9--sprite",
  "use": "bell-8b0530d9--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"bell-8b0530d9--sprite\"><rect width=\"36\" height=\"36\" fill=\"none\" /><g transform=\"translate(-1541 -3850)\"><path d=\"M1574.346,3880.194a.2.2,0,0,0-.027-.08l-1.872-3.42v-2.074a4.376,4.376,0,0,0-2.906-4.147c0-.037.011-.071.011-.109a1.49,1.49,0,0,0-.87-1.349c-.01,0-.017-.011-.027-.015a1.309,1.309,0,0,0-.169-.056,1.2,1.2,0,0,0-.116-.036,1.168,1.168,0,0,0-.14-.017,1.28,1.28,0,0,0-.144-.017h-.029c-.048,0-.094.01-.141.014a1.306,1.306,0,0,0-.138.014,1.543,1.543,0,0,0-.219.063c-.016.006-.034.01-.05.016a1.493,1.493,0,0,0-.945,1.385c0,.044.01.085.013.129a8.035,8.035,0,0,0-1.62,1.021,4.387,4.387,0,0,0-1.277,3.117v2.073l-1.883,3.4a.187.187,0,0,0-.026.079.81.81,0,0,0,.156.9.821.821,0,0,0,.567.238h3.784a1.794,1.794,0,0,0,3.067,1.214,1.986,1.986,0,0,0,.533-1.214h3.743a.766.766,0,0,0,.567-.238A.787.787,0,0,0,1574.346,3880.194Z\" transform=\"translate(-9.055 -8.257)\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
